export enum CONTACTS {
  PHONE_NUMBER = 'phoneNumber',
  MOBILE_NUMBER = 'mobileNumber',
  FAX_NUMBER = 'faxNumber',
  EMERGENCY_NUMBER = 'emergencyNumber',
  WHATSAPP_NUMBER = 'whatsappNumber',
  WEBSITE = 'website',
  EMAIL = 'email',
}

export const PHONES_CONTACTS = [
  CONTACTS.PHONE_NUMBER,
  CONTACTS.MOBILE_NUMBER,
  CONTACTS.EMERGENCY_NUMBER,
  CONTACTS.WHATSAPP_NUMBER,
];
export const ADDITIONAL_CONTACTS = [CONTACTS.EMAIL, CONTACTS.WEBSITE, CONTACTS.FAX_NUMBER];
